import { render } from "./CandidateCart.vue?vue&type=template&id=1fd7a3f0&scoped=true"
import script from "./CandidateCart.vue?vue&type=script&lang=js"
export * from "./CandidateCart.vue?vue&type=script&lang=js"

import "./CandidateCart.vue?vue&type=style&index=0&id=1fd7a3f0&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd7a3f0"]])

export default __exports__